import { useNavigate } from "react-router-dom";
import ContentHeader from "../contentHeader/ContentHeader";
import { useResources } from "../../hooks/useResources";
import { usePermissions } from "../../hooks/usePermissions";

interface JobDetailsHeaderProps {
  jobId: string;
  jobType?:string;
  onDownloadZip?: () => void | Promise<void>;
}

const JobDetailsHeader = ({ jobId, jobType, onDownloadZip }: JobDetailsHeaderProps) => {
  const navigate = useNavigate();
  const { getResourceValue } = useResources();
  const { canReUploadJobs } = usePermissions();

  const handleReUpload = () => {
    // Navigate based on job type and pass jobId via state for re-upload
    const reUploadPath = jobType === "update" ? "/update-jobs" : "/upload-jobs";
    navigate(reUploadPath, { state: { jobId } });
  };

  return (
    <ContentHeader
      title={jobId}
      headingLevel={1}
      className="content-header--job-details-header"
      actions={
        <>
          <button className="btn btn-white" onClick={onDownloadZip}>
            <i className="f-icon download-icon"></i>
            {getResourceValue("download_zip_file", "Download ZIP File")}
          </button>
          {canReUploadJobs && (
            <button className="btn btn-green" onClick={handleReUpload}>
              <i className="f-icon upload-icon"></i>
              {getResourceValue("re_upload", "Re-Upload")}
            </button>
          )}
        </>
      }
    />
  );
};

export default JobDetailsHeader;


